import React, { useState, useEffect } from "react";
import "./styles.css";
import RoughCountryBanner from "./rough-country-banner";
import FormattedDescription from "./formatted-description";
import WheelPackageModal from "./WheelPackageModal"


export default function RoughCountryFitment({ fitment, data }) {

    const features = data.features;
    const notes = data.notes;
    const description = data.product_description;
    const [openSection, setOpenSection] = useState(null);
    const wheelsData = parseTireInfo(data?.tire_info);
    const kitCategory = data?.category;
    const isKitCategory = Array.isArray(kitCategory) ? kitCategory.some(cat => cat.includes("Kits")) : kitCategory?.includes("Kits");

    const [showWheelModal, setShowWheelModal] = useState(false);


    useEffect(() => {
        if (showWheelModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showWheelModal]);


    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    function createUnorderedList(inputString) {
        const lines = inputString.split('\\\n').map(line => line.replace(/[^\x20-\x7E]/g, '').trim());
        const uniqueLines = new Set(lines.filter(line => line.length > 0));
        const listItems = Array.from(uniqueLines).map(line => `<li>${line}</li>`).join('\n');
        return `<ul>\n${listItems}\n</ul>`;
    }

    function createNotesList(inputString) {
        if (!inputString) return "";
        const sentences = inputString
            .split(". ")
            .map(sentence => sentence.trim())
            .filter(sentence => sentence.length > 0)
            .map(sentence =>
                sentence.endsWith(".") ? sentence : sentence + "."
            );
        return `
        <ul>
            ${sentences.map(sentence => `<li>${sentence}</li>`).join("")}
        </ul>
    `;
    }

    function parseTireInfo(tireInfoString) {
        if (!tireInfoString) return [];

        return tireInfoString
            .split(";")
            .map(item => item.trim())
            .filter(item => item.length > 0)
            .map(row => {
                const [size, wheel, boltPattern, offset, note] = row.split(":");

                return {
                    size: size || "-",
                    wheel: wheel || "-",
                    boltPattern: boltPattern || "-",
                    offset: offset || "-",
                    note: note && note !== "-" ? note : "-",
                    stance:
                        offset && parseInt(offset) <= -25
                            ? "Wide"
                            : offset && parseInt(offset) < 0
                                ? "Moderate"
                                : "-"
                };
            });
    }


    const handleClick = () => {
        setShowWheelModal(true)
    }


    return (
        <section className="fitment-section py-3">

            {/* Wheels section */}
            {isKitCategory && (
                <div className="wheel-matching-banner">
                    <div className="wheel-banner-content">

                        <div className="wheel-banner-left">
                            <img
                                src="https://images.ctfassets.net/auc1ums13y5u/7u1t8rtF38yFDplSxgZ2mY/ec08eba644754f5619684fdffa977aaf/tire-wheel-mb.png?h=137"
                                alt="Wheels and Tires"
                                className="wheel-banner-img"
                            />
                        </div>

                        <div className="wheel-banner-text">
                            <h2>SELECT MATCHING WHEELS AND TIRES</h2>
                            <p>
                                {/* FREE Mount, Balance, and Shipping! */}
                                <span
                                    className="wheel-banner-link"
                                    onClick={handleClick}
                                >
                                    Click Here to Add Wheels and Tires
                                </span>
                            </p>
                        </div>

                    </div>
                </div>
            )}

            <div className="container">

                <div className="row">
                    {/* <div className="col-lg-7"> */}
                    <div className={data?.notes && data.notes !== "nan" && data.notes !== "\\\r " && data.notes.length > 0 ? "col-lg-8" : "col-lg-12"}>
                        {data?.features && data.features !== "nan" && data.features.length > 0 ? (
                            <div>
                                <h3 className="mb-3"><strong>FEATURES</strong></h3>

                                {description && description !== "nan" && description.trim() !== "" && (
                                    <FormattedDescription description={description} />

                                )}
                                <div dangerouslySetInnerHTML={{ __html: createUnorderedList(features) }} />
                            </div>
                        ) : null}
                    </div>

                    <div className="col-lg-4 mt-5">
                        {data?.notes && data.notes !== "nan" && data.notes !== "\\\r " && data.notes.length > 0 ? (
                            <div className="border-note p-4" style={{ border: '1px solid #E81C2E' }}>
                                <p className="mb-2">
                                    <strong>
                                        <i className="fa fa-warning" style={{ marginRight: '20px', color: 'black', fontSize: '18px' }}></i>
                                        FITMENT NOTES
                                    </strong>
                                </p>
                                <div dangerouslySetInnerHTML={{ __html: createNotesList(notes) }} style={{ fontSize: "14px" }} />
                            </div>
                        ) : null}
                    </div>
                </div>

                <RoughCountryBanner />

                <div className="mt-4">
                    <h2 className="mb-4"><strong>INSTALLATION</strong></h2>

                    <div className="accordion-item">
                        <div
                            className={`accordion-header ${openSection === "install" ? "active" : ""}`}
                            onClick={() => toggleSection("install")}
                        >
                            <span>INSTALL GUIDES</span>
                            <span className={`arrow ${openSection === "install" ? "rotate" : ""}`}>
                                ▼
                            </span>
                        </div>

                        {/* {openSection === "install" && (
                            <div className="accordion-body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {data?.instructions_url ? (
                                    <>
                                        View Instruction Sheet
                                        <a
                                            href={data.instructions_url}
                                            download
                                            style={{ cursor: 'pointer' }}
                                            title="Download File"
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <i className="fa fa-download" style={{ fontSize: '20px', color: '#070707' }}></i>
                                        </a>
                                    </>
                                ) : (
                                    <p>No install guide available.</p>
                                )}
                            </div>
                        )} */}

                        {openSection === "install" && (
                            <div
                                className="accordion-body"
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                {data?.instructions_url ? (
                                    <>
                                        <span>View Instruction Sheet</span>

                                        <div className='download-btn'>
                                            <a
                                                href={data.instructions_url}
                                                download
                                                className="download-button"
                                                style={{
                                                    fontSize: 'medium',
                                                    float: 'right',
                                                    color: '#E81C2E',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textDecoration: 'none'
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    src="../icons/Download.svg"
                                                    alt="Download"
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        marginRight: '5px'
                                                    }}
                                                />
                                                Download
                                            </a>
                                        </div>
                                    </>
                                ) : (
                                    <p>No install guide available.</p>
                                )}
                            </div>
                        )}


                    </div>

                    <div className="accordion-item">
                        <div
                            className={`accordion-header ${openSection === "specifications" ? "active" : ""}`}
                            onClick={() => toggleSection("specifications")}
                        >
                            <span>SPECIFICATIONS</span>
                            <span className={`arrow ${openSection === "specifications" ? "rotate" : ""}`}>
                                ▼
                            </span>
                        </div>

                        {openSection === "specifications" && (
                            <div className="accordion-body">
                                {data?.category === "Tires" ? (
                                    <>
                                        {data?.weight && (
                                            <p> <strong>Shipping Weight:</strong> {data.weight} </p>
                                        )}

                                        {data?.width && (
                                            <p> <strong>Width:</strong> {data.width} </p>
                                        )}

                                        {data?.width && (
                                            <p> <strong>Height:</strong> {data.height} </p>
                                        )}

                                        {data?.width && (
                                            <p> <strong>Shipping Group:</strong> {data.shipping_group} </p>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {data?.install_time ? (
                                            <p>
                                                <strong>Est. Install Time:</strong> {data.install_time}
                                            </p>
                                        ) : (
                                            <p>No details available.</p>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="accordion-item">
                        <div
                            className={`accordion-header ${openSection === "inthebox" ? "active" : ""}`}
                            onClick={() => toggleSection("inthebox")}
                        >
                            <span>IN THE BOX</span>
                            <span className={`arrow ${openSection === "inthebox" ? "rotate" : ""}`}>
                                ▼
                            </span>
                        </div>

                        {openSection === "inthebox" && (
                            <div className="accordion-body">
                                {((data?.front_components && data.front_components !== 'nan') || (data?.rear_components && data.rear_components !== 'nan')) ? (
                                    <>
                                        <p style={{ color: "#E81C2E" }}>Front:</p>
                                        {data?.front_components && data.front_components !== 'nan' ? (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: createUnorderedList(data.front_components),
                                                }}
                                            />
                                        ) : null}

                                        <p style={{ color: "#E81C2E" }}>Rear:</p>
                                        {data?.rear_components && data.rear_components !== 'nan' ? (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: createUnorderedList(data.rear_components),
                                                }}
                                            />
                                        ) : null}
                                    </>
                                ) : (
                                    <p>No details available.</p>
                                )}
                            </div>
                        )}


                    </div>
                </div>


                <div >
                    {/* Vehicle Fitment Section */}
                    {(fitment && fitment.length > 0) || data.fitment ? (
                        <>
                            <div className="wheel-fitment-section mt-5">
                                <h2 className="mb-4"><strong>FITMENT</strong></h2>

                                {fitment && fitment.length === 0 ? (
                                    <p>{data.fitment}</p>
                                ) : (
                                    fitment && fitment.length > 0 && (
                                        <>
                                            <p className="mb-2"><strong>VEHICLE</strong></p>
                                            <div className="table-wrapper">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Year</th>
                                                            <th>Make</th>
                                                            <th>Model</th>
                                                            <th>Submodel</th>
                                                            <th>Drive</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {fitment.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.start_year === item.end_year ? item.start_year : `${item.start_year}-${item.end_year}`}</td>
                                                                <td>{item.make}</td>
                                                                <td>{item.model}</td>
                                                                <td>{item.submodel}</td>
                                                                <td>{item.drive}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )
                                )}
                            </div>
                        </>
                    ) : null}

                    {/* Wheels & Tires Section */}
                    <div>
                        {wheelsData && wheelsData.length > 0 && (
                            <div className="wheel-fitment-section mt-4">
                                <h5 className="mb-3"><strong>WHEELS & TIRES</strong></h5>
                                <div className="table-wrapper">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Size</th>
                                                <th>Wheel</th>
                                                <th>Bolt Pattern</th>
                                                <th>Wheel Offset</th>
                                                <th>Note</th>
                                                {/* <th>Stance</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {wheelsData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.size}</td>
                                                    <td>{item.wheel}</td>
                                                    <td>{item.boltPattern}</td>
                                                    <td>{item.offset}</td>
                                                    <td>{item.note}</td>
                                                    {/* <td>{item.stance}</td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Build Expert Help Banner */}
                <div className="build-expert-banner mt-5 mb-4">
                    <div className="banner-inner">

                        <div className="expert-image-wrapper">
                            <img
                                src="https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/local_images/images/extreme_logo.svg"
                                alt="Build Expert"
                                className="expert-img"
                            />
                        </div>

                        <div className="expert-content">

                            <p className="expert-heading">
                                <span className="need-help">NEED HELP?</span>
                                <span className="talk-text">TALK TO A BUILD EXPERT</span>
                            </p>

                            <div className="contact-options">
                                <a href="tel:18002227023">
                                    <i className="fa fa-phone"></i>
                                    480-892-9433
                                </a>

                                <a href="mailto:sales@extremeperformance.com">
                                    <i className="fa fa-envelope"></i>
                                    Email Us
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>


            {/* Modal */}
            <WheelPackageModal
                show={showWheelModal}
                data={data}
                onClose={() => setShowWheelModal(false)}
            />
        </section>
    );
}
